import { AxiosResponse } from 'axios';
import { SET_PROJECTS, SET_PROJECT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_PROJECT_ISLOADING,
  DELETE_PROJECT,
  EDIT_PROJECT,
  GET_PROJECTS,
  GET_PROJECT,
  REGISTER_PROJECT,
  TOGGLE_PROJECT_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import Project from '@/services/project';
import { Module } from 'vuex';
import { EditProject, RegisterProject, GetProject } from '@/dtos/project.dto';

const project: Module<any, {}> = {
  state: {
    project: {
      data: null,
      isLoading: false,
    },
    projects: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    project: (state: { project: any }) => state.project,
    projects: (state: { projects: any }) => state.projects,
  },
  mutations: {
    [SET_PROJECT]: (
      state: { project: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.project.data = payload.data) : null,
        (state.project.isLoading = payload.isLoading);
    },
    [SET_PROJECTS]: (
      state: { projects: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.projects.data = payload.data) : null,
        (state.projects.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_PROJECT]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT, { data: null, isLoading: true });

      const result: AxiosResponse = await Project.registerProject(
        payload as RegisterProject
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECTS]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECTS, { data: null, isLoading: true });

      const result: AxiosResponse = await Project.getProjects(
        payload as GetProject
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECTS, { isLoading: false });
        return false;
      }
    },
    [GET_PROJECT]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT, { data: null, isLoading: true });

      const result: AxiosResponse = await Project.getProjects(
        payload as GetProject
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_PROJECT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT, { isLoading: false });
        return false;
      }
    },
    [EDIT_PROJECT]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT, { data: null, isLoading: true });

      const result: AxiosResponse = await Project.editProject(
        payload as EditProject
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_PROJECT_IS_ACTIVE]: async ({ commit }: any, payload: any) => {
      commit(SET_PROJECT, { isLoading: true });

      const result: AxiosResponse = await Project.toggleProjectIsActive(
        payload as EditProject
      );

      if (result) {
        if (result.data.status) {
          commit(SET_PROJECT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT, { isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT, { isLoading: false });
        return false;
      }
    },
    [DELETE_PROJECT]: async ({ commit }: any, payload: string) => {
      commit(SET_PROJECT, { data: null, isLoading: true });

      const result: AxiosResponse = await Project.deleteProject(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_PROJECT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_PROJECT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_PROJECT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_PROJECT_ISLOADING]: ({ commit }) => {
      commit(SET_PROJECT, { isLoading: false });
      commit(SET_PROJECTS, { isLoading: false });
    },
  },
};

export default project;

